export const FETCH_BENEFICIARIES_LIST = 'FETCH_BENEFICIARIES_LIST';
export const FETCH_BENEFICIARIES_LIST_SUCCESS = 'FETCH_BENEFICIARIES_LIST_SUCCESS';
export const FETCH_BENEFICIARIES_LIST_FAILURE = 'FETCH_BENEFICIARIES_LIST_FAILURE';
export const CLEAR_BENEFICIARIES_LIST = 'CLEAR_BENEFICIARIES_LIST';

